import React, { useRef } from "react";
import { Row, Col, Card, Button, Layout } from "antd";
import { CheckOutlined, ArrowRightOutlined, ArrowLeftOutlined } from "@ant-design/icons";
import "./PricingSection.scss";
import "../../App.scss";
import Slider from "react-slick";
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import { PORTAL_BASE_URL, REGISTER_POSTHOG_API_KEY, POSTHOG_API_HOST } from "../../env";
import { useHistory } from "react-router-dom";
import posthog from "posthog-js";

const { Content } = Layout;

const customerImages = [
    "/ai_creator/pricing_gallery/gallery-img1.jpg",
    "/ai_creator/pricing_gallery/gallery-img2.jpg",
    "/ai_creator/pricing_gallery/gallery-img3.jpg",
    "/ai_creator/pricing_gallery/gallery-img4.jpg",
    "/ai_creator/pricing_gallery/gallery-img5.jpg",
    "/ai_creator/pricing_gallery/gallery-img6.jpg",
    "/ai_creator/pricing_gallery/gallery-img7.jpg",
    "/ai_creator/pricing_gallery/gallery-img8.jpg",
    "/ai_creator/pricing_gallery/gallery-img9.jpg",
    "/ai_creator/pricing_gallery/gallery-img10.jpg",
];

const features = [
    "Unlimited product uploads",
    "Unlimited image generations",
    "Asset management",
    "Sharing & cloud storage",
    "Live onboarding session",
    "Editing tools like magic erase, resize, etc."
];

const PricingSection = () => {
    return (
        <>
            <WebVersion />
            <MobileVersion />
        </>
    );
};

const WebVersion = () => {
    const history = useHistory();
    const utm_source = localStorage.getItem('utm_source') || null;
    let sliderRef = useRef(null);

    let settings = {
        autoplay: false,
        dots: false,
        infinite: true,
        arrows: false,
        speed: 600,
        // show 4.5 slides so the last slide is partially visible
        slidesToShow: 4.5,
        slidesToScroll: 1,
        vertical: false,
    };

    const next = () => {
        if (sliderRef) {
            sliderRef.slickNext();
        }
    };

    const prev = () => {
        if (sliderRef) {
            sliderRef.slickPrev();
        }
    };

    return (
        <Content className="d-none d-lg-block">
            <Row className="container-fluid pricing-section-wrapper">
                <Col span={24}>
                    <div className="pricing-title-row">
                        <div className="manrope f-50 w-600 lh-60 black-085 pricing-title">
                            Customer AI images created on ALL3D
                        </div>
                        <Button
                            className="manrope f-14 w-700 lh-22 see-gallery-btn"
                            onClick={() => { history.push('/image-gallery'); }}
                        >
                            View Image Gallery
                        </Button>
                    </div>
                </Col>

                <Col span={24} className="pricing-carousel-container">
                    <div className="pricing-carousel-wrapper-inner">
                        <Slider
                            ref={slider => {
                                sliderRef = slider;
                            }}
                            {...settings}
                            className="pricing-slider-setting"
                        >
                            {customerImages.map((img, index) => (
                                <Card key={index} className="pricing-image-card" bordered={false}>
                                    <img loading="lazy" src={img} alt={`Customer AI ${index + 1}`} className="pricing-customer-img" />
                                </Card>
                            ))}
                        </Slider>
                    </div>
                    <div className="pricing-nav-controls">
                        <Button
                            onClick={prev}
                            icon={<ArrowLeftOutlined className="manrope f-20 lh-0" />}
                            className="pricing-slider-btn"
                        />
                        <Button
                            onClick={next}
                            icon={<ArrowRightOutlined className="manrope f-20 lh-0" />}
                            className="pricing-slider-btn"
                        />
                    </div>
                </Col>

                <Col span={24} className="pricing-bottom-section">
                    <Row className="pricing-content-card">
                        <Col span={12} className="pricing-left-content">
                            <div className="manrope f-30 w-600 lh-40 black-085 pricing-card-title">
                                Flexible pricing based on your needs
                            </div>
                            <div className="manrope f-16 w-500 lh-24 black-085 pricing-card-subtitle">
                                Bundles and subscriptions as low as <strong>$35 per image</strong>
                            </div>
                            <div className="pricing-buttons">
                                <Button
                                    className="manrope f-16 w-700 lh-24 pricing-primary-btn"
                                    onClick={() => {
                                        const urlParams = new URLSearchParams(window.location.search);
                                        const email = urlParams.get('email') || "";
                                        const ph = posthog.init(REGISTER_POSTHOG_API_KEY, {
                                            api_host: POSTHOG_API_HOST,
                                            autocapture: false,
                                            name: "register",
                                            capture_pageview: false,
                                            loaded: (ph) => {
                                                if (utm_source) ph.register({ utm_source: utm_source });
                                            },
                                        });
                                        if (ph) {
                                            ph.capture('free_trial_click', {
                                                location: window.location.pathname,
                                                button: 'get_started_for_free',
                                                utm_source: utm_source,
                                                email: email
                                            });
                                        }
                                        window.open(`${PORTAL_BASE_URL}/register?redirectURL=ai-asset-creator&utm_source=${utm_source}`, "_blank")
                                    }}
                                >
                                    Get started for free
                                </Button>
                                <Button
                                    className="manrope f-16 w-700 lh-24 pricing-secondary-btn"
                                    onClick={() => { history.push('/pricing'); }}
                                >
                                    View pricing & plans
                                </Button>
                            </div>
                        </Col>
                        <Col span={12} className="pricing-right-content">
                            <div className="manrope f-14 w-700 lh-22 black-085 pricing-features-title">
                                Your 4K product images, plus:
                            </div>
                            <ul className="pricing-features-list">
                                {features.map((feature, index) => (
                                    <li key={index} className="manrope f-14 w-500 lh-22 dark">
                                        <span className="check-circle">
                                            <CheckOutlined className="f-12 white" />
                                        </span>
                                        {feature}
                                    </li>
                                ))}
                            </ul>
                        </Col>
                    </Row>
                </Col>
            </Row>
        </Content>
    );
};

const MobileVersion = () => {
    const history = useHistory();
    const utm_source = localStorage.getItem('utm_source') || null;

    const settings = {
        autoplay: false,
        dots: false,
        infinite: true,
        arrows: false,
        speed: 600,
        slidesToShow: 1.1,
        slidesToScroll: 1,
        vertical: false,
        initialSlide: 0,
        // use centerMode + centerPadding to show a stable peek of the adjacent slide
        centerMode: true,
        centerPadding: '24px',
        variableWidth: false
    };

    return (
        <Content className="d-lg-none">
            <Row className="container-fluid pricing-section-wrapper-mobile">
                <Col span={24}>
                    <div className="pricing-title-row-mobile">
                        <div className="manrope f-38 w-600 lh-46 black-085 pricing-title-mobile">
                            Customer AI images created on ALL3D
                        </div>
                        <Button
                            className="manrope f-14 w-700 lh-22 see-gallery-btn"
                            onClick={() => { history.push('/image-gallery'); }}
                        >
                            View Image Gallery
                        </Button>
                    </div>
                </Col>

                <Col span={24} className="pricing-carousel-mobile">
                    <Slider
                        {...settings}
                        className="pricing-slider-setting-mobile"
                    >
                        {customerImages.map((img, index) => (
                            <Card key={index} className="pricing-image-card-mobile" bordered={false}>
                                <img loading="lazy" src={img} alt={`Customer AI ${index + 1}`} className="pricing-customer-img-mobile" />
                            </Card>
                        ))}
                    </Slider>
                </Col>

                <Col span={24} className="pricing-bottom-mobile">
                    <Row className="pricing-content-card-mobile">
                        <Col span={24} className="pricing-mobile-content">
                            <div className="manrope f-20 w-600 lh-28 dark pricing-mobile-title">
                                Flexible pricing based on your needs
                            </div>
                            <div className="manrope f-14 w-500 lh-22 dark pricing-mobile-subtitle">
                                Bundles and subscriptions as low as <strong>$35 per image</strong>
                            </div>
                            <div className="manrope f-14 w-700 lh-22 dark pricing-mobile-features-title">
                                Your 4K product images, plus:
                            </div>
                            <ul className="pricing-features-list-mobile">
                                {features.map((feature, index) => (
                                    <li key={index} className="manrope f-14 w-500 lh-22 dark">
                                        <span className="check-circle">
                                            <CheckOutlined className="f-10 white" />
                                        </span>
                                        {feature}
                                    </li>
                                ))}
                            </ul>
                            <div className="pricing-buttons-mobile">
                                <Button
                                    className="manrope f-16 w-700 lh-24 pricing-primary-btn-mobile"
                                    onClick={() => {
                                        const urlParams = new URLSearchParams(window.location.search);
                                        const email = urlParams.get('email') || "";
                                        const ph = posthog.init(REGISTER_POSTHOG_API_KEY, {
                                            api_host: POSTHOG_API_HOST,
                                            autocapture: false,
                                            name: "register",
                                            capture_pageview: false,
                                            loaded: (ph) => {
                                                if (utm_source) ph.register({ utm_source: utm_source });
                                            },
                                        });
                                        if (ph) {
                                            ph.capture('free_trial_click', {
                                                location: window.location.pathname,
                                                button: 'get_started_for_free',
                                                utm_source: utm_source,
                                                email: email
                                            });
                                        }
                                        window.open(`${PORTAL_BASE_URL}/register?redirectURL=ai-asset-creator&utm_source=${utm_source}`, "_blank")
                                    }}
                                >
                                    Get started for free
                                </Button>
                                <Button
                                    className="manrope f-16 w-700 lh-24 pricing-secondary-btn-mobile"
                                    onClick={() => { history.push('/pricing'); }}
                                >
                                    View pricing & plans
                                </Button>
                            </div>
                        </Col>
                    </Row>
                </Col>
            </Row>
        </Content>
    );
};

export default PricingSection;
